<template>
    <div id="survey-landing" :key="loadedLanguage">
        <survey-loader v-if="loading"> Generating a new survey... </survey-loader>
    </div>
</template>
<script src="./SurveyStart.ts"></script>
